
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gratuity/[appointment_id]",
      function () {
        return require("private-next-pages/gratuity/[appointment_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gratuity/[appointment_id]"])
      });
    }
  